<template>
  <v-container fluid>
    <instructions v-if="$store.getters['company/week'] === 0"></instructions>

    <stepper v-if="$store.getters['company/week'] > 0"></stepper>
    <kpi></kpi>
    <debrief></debrief>
    <v-btn
      v-if="$store.getters['company/week'] > 0"
      style="z-index: 99"
      fab
      dark
      color="primary"
      bottom
      left
      fixed
      @click="$store.commit('interfaceSettings/SET_kpi', true), $router.replace('/resume')"
    >
      <v-icon dark>mdi-chart-bar</v-icon>
    </v-btn>
    <v-btn
      v-if="$store.getters['game/debrief']"
      style="z-index: 99; left: 80px"
      fab
      dark
      color="secondary"
      bottom
      left
      fixed
      @click="$store.commit('interfaceSettings/SET_debrief', true); $router.replace('/debrief-resume')"
    >
      <v-icon dark>mdi-account-group</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import Instructions from "./Instructions";
import Stepper from "./stepper/Index";
import Kpi from "./kpi/Index";
import Debrief from "./debrief/Index";
export default {
  name: "Home",
  components: {
    Instructions,
    Stepper,
    Kpi,
    Debrief
  },
  mounted() {
    this.subscribeSocket();
  },
  methods: {
    subscribeSocket() {
      if (this.$store.state.game.data !== null) {
        this.$socket.emit("subscribe", this.$store.state.game.data._id);
      }
    }
  }
};
</script>
